const Main = () => import('./Main')

const route = {
  path: '/',
  name: 'home',
  meta: {
    title: 'Home - A D M A N 2 0 1 9'
  },
  component: Main
}

export default route
